module.exports = __webpack_public_path__ + "static/assets/1b636eacc3c2152c793b7100d0ef5f3d.png";